import { AlertJsMessage } from './../../helpers.js'

let movedIndex = 100;

//looks through the parents of the new item to see if it is a child of a circuit.
export const inCircuit = (items, newIndex) => {
	let isInCircuit = false;
	for (let i = 0; i < newIndex; i++) {
		let item = items[i];
		if (item && item.type === 'circuit' && item.child) {
			isInCircuit = true;
		} else if(item && item.type === 'circuit' && item.parent){
			isInCircuit = false;
		}
	}
	return isInCircuit;
}

export const movedIndexInc = () => {
		movedIndex = movedIndex + 1;
}

export const circuitData = (items, newIndex) => {
	let curcuitData = {};
	for (let i = 0; i < newIndex; i++) {
		let item = items[i];
		if (item && item.type === 'circuit' && item.child) {
			curcuitData = item;
		} else if(item && item.type === 'circuit' && item.parent){
			curcuitData = {};
		}
	}
	return curcuitData;
}

const checkCircuitOrder = (list) => {
	let parent = null;
	let child = null;
	for (let i = 0; i <list.length; i++) {
		if (list[i].child) {
			if (parent) {
				AlertJsMessage('A');
			} else {
				child = list[i].child;
			}
		}
		if (list[i].parent) {
			if (child && list[i].id === child) {} else {
				AlertJsMessage("Circuit out of order! Make sure circuit Start and End maintain order. Circuits cannot contain other circuits.");
				return false;
			}
		}
		if (list[i].type === 'block' && list[i].inCircuit) {
			AlertJsMessage("Blocks cannot be placed into a circuit.");
			return false;
		}
	}
	return true;
}

/**
 * Moves an item from one list to another list.
 */
export const move = (source, destination, droppableSource, droppableDestination) => {
	const sourceClone = Array.from(source);
	const destClone = Array.from(destination);
	const [removed] = sourceClone.splice(droppableSource.index, 1);
	if (removed.type === 'circuit') {
		movedIndex = movedIndex + 1;
		const startId = `item-${movedIndex}`;
		movedIndex = movedIndex + 1;
		const endId = `item-${movedIndex}`;
		destClone.splice(droppableDestination.index, 0, {
			id: startId,
			content: `Circuit #${movedIndex} Start`,
			child: endId,
			type: 'circuit'
		});
		destClone.splice(droppableDestination.index + 1, 0, {
			id: endId,
			content: `Circuit #${movedIndex} End`,
			parent: startId,
			type: 'circuit'
		});
	} else if (removed.type === 'block') {
		movedIndex = movedIndex + 1;
		let blockData = {
			id: `item-${movedIndex}`,
			data: removed.data,
			content: removed.content,
			type: 'block',
			inCircuit: inCircuit(destClone, droppableDestination.index)
		};
		destClone.splice(droppableDestination.index, 0, blockData);

	} else {
		//NORMAL EXERCISE
		const cir = circuitData(destClone, droppableDestination.index);
		movedIndex = movedIndex + 1;
		destClone.splice(droppableDestination.index, 0, {
			id: `item-${movedIndex}`,
			data: removed.data,
			content: removed.content,
			type: 'plan',
			inCircuit: inCircuit(destClone, droppableDestination.index),
			cirStartId: cir.id
		});
	}
	const result = {};
	result[droppableSource.droppableId] = source;
	result[droppableDestination.droppableId] = destClone;
	if (checkCircuitOrder(destClone)) {
		result[droppableDestination.droppableId] = destClone;
	} else {
		return null;
	}
	return result;
};

export const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	if (result.length && result[endIndex]) {
		result[endIndex].inCircuit = inCircuit(result, endIndex);
		if (result[endIndex].type === 'circuit') {
			return list;
		}
		if (result[endIndex].type === 'plan' && result[endIndex].inCircuit) {
			result[endIndex].formData.sets = 1;
		}
		if (checkCircuitOrder(result)) {
			return result;
		}
	}
	return list;
};



// WEBPACK FOOTER //
// ./src/components/workouts/_dndlogic.js